<template>
  <div class="selectArea">
    <VoiceTypeOption
      v-for="item in options"
      :key="item.value"
      :option="item"
      :isPlayingOptionId="isPlayingOptionId"
      :audioSourceStatus="isPlayingOptionId === item.id ? audioSourceStatus : VoiceStatus.Unready"
      @handleSelect="handleSelect"
      @handlePlay="handlePlay"/>
      <audio controls ref="audioRef" class="audioArea" @ended="handleEnd">
          <source :src="''"/>
      </audio>
  </div>
</template>

<script>
import VoiceTypeOption from './VoiceTypeOption.vue'
import { VoiceStatus } from '../config'
export default {
  name: 'VoiceTypeSelect',
  components: {
    VoiceTypeOption
  },
  props: {
    options: {
        type: Array,
        default: () => []
    }
  },

  data() {
    return {
      isPlayingOptionId: undefined,
      audioSourceStatus: VoiceStatus.Unready,

      VoiceStatus
    };
  },

  methods: {
    handleSelect(value) {
      this.$emit('handleVoiceSelect', value)
    },

    async handlePlay(option, isPlaying) {
        if (this.isPlayingOptionId === option.id) {
          if (isPlaying) {
            this.$refs.audioRef.pause();
            this.audioSourceStatus = VoiceStatus.Unready;
          } else {
            this.$refs.audioRef.play();
            this.audioSourceStatus = VoiceStatus.Playing;
          }
        } else {
          this.audioSourceStatus = VoiceStatus.Loading;

          this.isPlayingOptionId = option.id;

          try {
              const response = await fetch(option.url);

              if(response.status >= 400) {
                  this.$message.error('音频文件加载失败');
                  return;
              }

              this.$refs.audioRef.src= option.url;

              this.$refs.audioRef.play();
              this.audioSourceStatus = VoiceStatus.Playing;
          } catch(err) {
              console.error(err);
              this.audioSourceStatus = VoiceStatus.Unready;
          }
        }
    },

    handleEnd() {
        this.audioSourceStatus = VoiceStatus.Unready;
    },
  }
}
</script>

<style lang="scss" scoped>
.selectArea {
    width: 100%;
    height: 230px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: flex-start;
    column-gap: 10px;
    row-gap: 4px;

    .audioArea {
      opacity: 0;
      width: 1px;
      height: 1px;
    }
}

.h5 {
  .selectArea {
    height: 270px;
  }
}

.rich {
  .selectArea {
    height: 250px;
  }
}
</style>
